/* eslint-disable jsx-a11y/aria-props */
/* eslint-disable no-nested-ternary */
// @ts-nocheck
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import AutoModeIcon from '@mui/icons-material/AutoMode';

import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LockResetIcon from '@mui/icons-material/LockReset';
import RefreshIcon from '@mui/icons-material/Refresh';
import {
  Badge,
  Box,
  Chip,
  Collapse,
  Grid,
  IconButton,
  Slide,
  styled,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useContextMenu } from 'react-contexify';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as CodeOffIcon } from '../../assets/images/codeIcon.svg';
import { ReactComponent as CollapseIcon } from '../../assets/images/DatasetBarCollapseIcon.svg';
import { ReactComponent as ExpandMoreIcon } from '../../assets/images/DatasetBarExpandIcon.svg';
import { ReactComponent as DatasetIcon } from '../../assets/images/DatasetsIcon.svg';
import { ReactComponent as DeleteIcon } from '../../assets/images/Delete.svg';
import {
  DATASET_REQUIRED_FIELDS,
  DS_LOCKED_MSG,
  DS_RECALIBRATION_MSG,
} from '../../const/CommonConst';
import MODULE_SUB_MODULE_OPERATIONS_TREE from '../../const/ModuleSubModuleOperationsTree';
import useDataIngestion from '../../Hooks/DM/useDataIngestion';
import utils from '../../utils/utils';
import CustomCarousel from '../AllCustomComponents/CustomCarousel/CustomCarousel';
import { ContextMenus } from './ContextMenus';
import DeleteConfirmModal from './DeleteConfirmModal';
import RecalibrationModal from './RecalibrationModal';
import SwalToast from './SwalToast';
import TransperentSearchBox from './TransperentSearchBox';

const PREFIX = 'OperationCards';
const classes = {
  badge: `${PREFIX}-badge`,
  operationsIcons: `${PREFIX}-operationsIcons`,
  root: `${PREFIX}-root`,
  chip: `${PREFIX}-chip`,
  activeChip: `${PREFIX}-activeChip`,
  operationDiv: `${PREFIX}-operationDiv`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`& .${classes.badge}`]: {
    left: 0,
    top: 0,
    borderWidth: theme.spacing(0.3),
    borderColor: '#ffffff',
    borderStyle: 'solid',
    padding: theme.spacing(1),
    color: '#ffffff',
  },
  [`& .${classes.operationsIcons}`]: {
    height: theme.spacing(2),
    width: theme.spacing(2),
    marginLeft: theme.spacing(0.4),
  },
  [`& .${classes.chip}`]: {
    margin: theme.spacing(0.5),
  },
  [`& .${classes.operationDiv}`]: {
    borderRight: `${theme.spacing(0.1)} solid ${theme.palette.secondary.main}`,
    borderLeft: `${theme.spacing(0.1)} solid ${theme.palette.secondary.main}`,
  },
}));

// styled badge
const StyledBadge = Badge;

// eslint-disable-next-line react/prop-types
const VisuallyHidden = ({ children }) => (
  <span
    style={{
      position: 'absolute',
      clip: 'rect(0, 0, 0, 0)',
      overflow: 'hidden',
      height: '1px',
      width: '1px',
      margin: '-1px',
    }}
  >
    {children}
  </span>
);

/**
 * @function OperationChip
 * @description Operation Chip is a UI chip
 * @param {object} data - object conatining details of operation.
 * @param {boolean} isSteps - boolean to check if operation is steps or not.
 * @param {function} onClick - function to handle click on operation chip.
 * @param {string} className - className to be applied on chip.
 * @param {boolean} console - boolean to check if operation is console or not.
 * @param {string} color - color of chip.
 */
const OperationChip = ({
  data,
  isSteps,
  onClick,
  className,
  console,
  color,
}) => {
  return (
    <Chip
      title={console ? data.name : data.label}
      size="small"
      component="button"
      sx={{
        margin: '4px',
        overflow: 'hidden',
      }}
      icon={
        console ? (
          <Box pr={0.5}>
            <CodeOffIcon color="primary" role="img" />
          </Box>
        ) : (
          <Box display="flex" alignItems="center">
            {isSteps && (
              <StyledBadge
                badgeContent={data?.stepCount}
                color="primary"
                classes={{
                  badge: classes.badge,
                }}
                aria-label={data?.stepCount}
                role="banner"
              />
            )}
            <Box
              sx={{
                ml: isSteps && data.stepCount ? 4 : 1,
              }}
              role="img"
            >
              <img
                className={classes.operationsIcons}
                src={data.icon.default}
                alt=""
              />
            </Box>
          </Box>
        )
      }
      label={
        console ? (
          <Box display="flex" flexDirection="column">
            <Typography
              variant="body2"
              noWrap={true}
              aria-label={data?.name}
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {data.name}
            </Typography>
            <Typography
              sx={{
                fontSize: '7px',
              }}
              aria-label="Udf"
            >
              UDF
            </Typography>
            {/* Visually hidden text accessible to screen reader */}
            {color === 'secondary' && <VisuallyHidden>Selected</VisuallyHidden>}
          </Box>
        ) : (
          <>
            <Typography variant="body2" noWrap={true} aria-label={data?.label}>
              {data.label}
            </Typography>
            {/* Visually hidden text accessible to screen reader */}
            {color === 'secondary' && <VisuallyHidden>Selected</VisuallyHidden>}
          </>
        )
      }
      onClick={onClick}
      color={color}
      style={data.disabled ? { pointerEvents: 'none' } : {}}
      className={className}
    />
  );
};
OperationChip.defaultProps = {
  className: '',
  console: false,
  isSteps: false,
};
OperationChip.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
  onClick: PropTypes.func.isRequired,
  isSteps: PropTypes.bool,
  color: PropTypes.string.isRequired,
  className: PropTypes.string,
  console: PropTypes.bool,
};

/**
 * @function OperationCards
 * @description UI of Operation Card
 * @param {function} onOpClick - function to handle click on operation card.
 * @param {object} activeOperation - object conatining details of selected operation.
 * @param {array} operations - An array of operations
 * @param {object} activeDataset - currently active dataset
 * @param {function} onDqClick - function to handle click on dq button.
 * @param {array} datasets - An array of dataset
 * @param {object} activeProject - An object which store active projects in DatasetTable
 * @param {boolean} isSteps - boolean to check if operation is steps or not.
 * @param {string} module - module name
 * @param {string} subModule - sub module name
 * @param {function} trackEntryExitTime - function to track entry and exit time of operation
 * @param {object} project - An object which store active projects in DatasetTable
 * @param {array} udfs - An array of udfs
 * @param {function} setSelectedUdf - function to set selected udf
 * @param {object} selectedUdf - An object which store selected udf
 * @param {function} changeTab - function to change tab
 * @returns {JSX.Element}
 */
const OperationCards = ({
  // eslint-disable-next-line no-unused-vars
  onOpClick = (_d) => {},
  activeOperation,
  operations,
  activeDataset,
  onDqClick,
  datasets,
  activeProject,
  isSteps,
  module,
  subModule = '',
  trackEntryExitTime = () => {},
  project = {},
  udfs,
  setSelectedUdf,
  selectedUdf,
  changeTab,
  fetchDatasetList,
}) => {
  useEffect(() => {
    if (activeOperation?.key && activeOperation?.key !== ' ') {
      const operationEntryPayload = {
        module,
        sub_module: subModule,
        operation: activeOperation?.key,
        entry_flag: true,
        entry_timestamp: Math.floor(Date.now() / 1000),
        project_id: project?.activeProject?.project_id,
      };
      trackEntryExitTime(operationEntryPayload);
      return () => {
        const operationExitPayload = {
          module,
          sub_module: subModule,
          operation: activeOperation?.key,
          exit_flag: true,
          exit_timestamp: Math.floor(Date.now() / 1000),
          project_id: project?.activeProject?.project_id,
        };
        trackEntryExitTime(operationExitPayload);
      };
    }
  }, [activeOperation?.key]);

  // Change
  const navigate = useNavigate();
  const { deleteDatasetsWithTableName, recalibrateDataset } =
    useDataIngestion();
  const [searchData, setSearchData] = useState('');
  const [searchOperationData, setSearchOperationData] = useState('');
  const [isOperationExpanded, setIsOperationExpanded] = useState(false);
  const [isDataExpanded, setIsDataExpanded] = useState(false);
  const [deleteDatasetId, setDeleteDatasetId] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecalibrateModal, setShowRecalibrateModal] = useState(false);

  const onRefresh = useCallback(() => {
    fetchDatasetList(
      project?.activeProject?.project_id,
      true,
      [
        DATASET_REQUIRED_FIELDS,
        'mvperc',
        'categorical_threshold',
        'stages',
        'fields',
      ].join()
    );
  }, [fetchDatasetList, project?.activeProject?.project_id]);

  const filteredOperationsArray = React.useMemo(
    () =>
      (Array.isArray(operations)
        ? operations
        : Object.values(operations)
      ).filter((ele) => {
        if (ele.showOp) {
          return searchOperationData
            ? ele.label
                ?.toLowerCase()
                .includes(searchOperationData?.toLowerCase())
            : ele;
        }

        if (ele.showOp) {
          return searchOperationData
            ? ele.key
                ?.toLowerCase()
                .includes(searchOperationData?.toLowerCase())
            : ele;
        }
        return false;
      }),
    [operations, activeProject, searchOperationData]
  );

  const filteredUdfsArray = React.useMemo(
    () =>
      udfs.filter((ele) =>
        searchOperationData
          ? ele.name?.toLowerCase().includes(searchOperationData?.toLowerCase())
          : ele
      ),
    [searchOperationData, udfs]
  );

  const udfToShowInOp = filteredUdfsArray
    ?.filter((data) => data.show_in_op_bar === true)
    ?.filter((item) => {
      const sidebarSplitArray = item?.tags?.sidebar?.map(
        (sidebarEl) => sidebarEl?.split('_')[1]
      );

      const isSidebarTermFound = sidebarSplitArray?.find(
        (sideSplitEl) => sideSplitEl === subModule
      );

      if (isSidebarTermFound) return true;

      return false;
    });

  const searchBasedFilter = React.useMemo(() => {
    return datasets?.filter((ele) =>
      searchData
        ? ele.table_display_name
            ?.toLowerCase()
            .includes(searchData?.toLowerCase())
        : ele
    );
  }, [searchData, datasets, deleteDatasetId]);

  const filteredDatasetsArray = React.useMemo(
    () =>
      searchBasedFilter.filter(
        (data) =>
          (data.preprocessed === 'done' ||
            data?.preprocessed === 'recalibrating') &&
          (data.published === true ||
            (data.published === false &&
              module === MODULE_SUB_MODULE_OPERATIONS_TREE.DM.key))
      ),
    [searchBasedFilter, module]
  );

  const filteredDatasetsNotReadyToUseArray = React.useMemo(
    () =>
      datasets?.filter(
        (item) =>
          item.preprocessed === 'done' &&
          item.published === false &&
          module !== MODULE_SUB_MODULE_OPERATIONS_TREE.DM.key
      ),
    [module, datasets]
  );
  const handleOnChange = useCallback(
    (e) => {
      setSearchOperationData(e.target.value);
    },
    [setSearchOperationData]
  );
  const onClickHandler = useCallback(() => {
    setIsOperationExpanded(!isOperationExpanded);
  }, [setIsOperationExpanded, isOperationExpanded]);

  const { show: showDatasetOperationMenus } = useContextMenu();
  const menus = useMemo(
    () => [
      {
        label: `Recalibrate/Reset dataset`,
        id: 'ds_recal',
        icon: AutoModeIcon,
        isMenuDisabled: ({ props: data }) =>
          project?.activeProject?.is_completed === true ||
          data?.datalock === false ||
          (data?.datalock === true && data?.preprocessed === 'recalibrating'),
        onClick: ({ props: data }) => {
          setDeleteDatasetId(data);
          setShowRecalibrateModal(true);
        },
      },
      {
        label: 'Delete dataset',
        id: 'ds_delete',
        icon: DeleteIcon,
        isMenuDisabled: () => project?.activeProject?.is_completed === true,
        onClick: ({ props: data }) => {
          setShowDeleteModal(true);
          setDeleteDatasetId(data);
        },
      },
    ],
    [
      setDeleteDatasetId,
      setShowRecalibrateModal,
      setShowDeleteModal,
      project?.activeProject?.is_completed,
    ]
  );
  const handleDeleteDataset = useCallback(() => {
    deleteDatasetsWithTableName(
      [deleteDatasetId],
      project?.activeProject?.project_id,
      () => {
        SwalToast({
          icon: 'success',
          title: 'Dataset deleted successfully.',
        });
        fetchDatasetList(
          project?.activeProject?.project_id,
          true,
          [
            DATASET_REQUIRED_FIELDS,
            'mvperc',
            'categorical_threshold',
            'stages',
            'fields',
          ].join()
        );
      },
      () => {
        SwalToast({
          icon: 'error',
          title: 'Failed to delete dataset.',
        });
      }
    );
    setShowDeleteModal(false);
  }, [setShowDeleteModal, deleteDatasetsWithTableName, deleteDatasetId]);

  const handleRecalibrateDataset = useCallback(() => {
    const payload = {
      dataset_id: deleteDatasetId?.id,
      project_id: project?.activeProject?.project_id,
    };
    recalibrateDataset(payload).then((res) => {
      SwalToast({
        icon: 'success',
        title: res?.data?.response,
      });
      fetchDatasetList(
        project?.activeProject?.project_id,
        true,
        [
          DATASET_REQUIRED_FIELDS,
          'mvperc',
          'categorical_threshold',
          'stages',
          'fields',
        ].join()
      );
    });
    setShowRecalibrateModal(false);
  }, [recalibrateDataset, setShowRecalibrateModal, deleteDatasetId]);

  const handleCloseDeleteModal = useCallback(() => {
    setShowDeleteModal(false);
    setDeleteDatasetId({});
  }, [setDeleteDatasetId, setShowDeleteModal]);

  const handleCloseRecalibrateModal = useCallback(() => {
    setShowRecalibrateModal(false);
    setDeleteDatasetId({});
  }, [setDeleteDatasetId, setShowRecalibrateModal]);

  const getIcon = useCallback(
    (data) => {
      switch (true) {
        case data?.preprocessed === 'recalibrating':
          return <LockResetIcon color="primary" />;
        case data?.datalock:
          return <LockOutlinedIcon color="primary" />;
        default:
          return <></>;
      }
    },
    [datasets]
  );
  const getTitle = useCallback(
    (data) => {
      switch (true) {
        case data?.preprocessed === 'recalibrating':
          return DS_RECALIBRATION_MSG;
        case data?.datalock:
          return DS_LOCKED_MSG;
        default:
          return `Display Name: ${data?.table_display_name} \nDataset: ${data?.dataset}`;
      }
    },
    [datasets]
  );

  return (
    <>
      <Slide direction="left" in={true} timeout={700}>
        <StyledBox
          sx={{
            width: {
              xs: '100%',
              md: '50%',
            },
            border: 2,
            borderColor: 'secondary.main',
            borderStyle: 'solid',
            padding: '8px',
            borderRadius: 1,
            height: isOperationExpanded ? 'auto' : '60px',
          }}
        >
          <Box>
            <Collapse in={isOperationExpanded} collapsedSize={46}>
              <Grid container direction="row" item={true} xs={12}>
                {operations && Object.values(operations)?.length !== 0 ? (
                  <Grid item xs={12}>
                    <Grid item xs={12}>
                      <Box
                        display="flex"
                        alignItems={!isOperationExpanded ? 'center' : 'start'}
                      >
                        <Box
                          mt={isOperationExpanded && 1}
                          display="flex"
                          alignItems="center"
                          flexDirection="row"
                        >
                          <Typography variant="body1" mr={2}>
                            Operations
                          </Typography>
                        </Box>

                        <Box
                          flexGrow={1}
                          overflow="hidden"
                          position="relative"
                          mt={0}
                          className={classes.operationDiv}
                        >
                          {!isOperationExpanded ? (
                            <CustomCarousel
                              elements={[
                                ...filteredOperationsArray.map(
                                  (data, index) => (
                                    <Box
                                      key={data?.objKey}
                                      id={`${module}_ops_cards_ops_op_${data?.key}`}
                                      component="ul"
                                      role="list"
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: 0,
                                        margin: 0,
                                        listStyleType: 'none',
                                      }}
                                    >
                                      <Box
                                        component="li"
                                        role="listitem"
                                        sx={{ listStyleType: 'none' }}
                                      >
                                        <OperationChip
                                          data={data}
                                          isSteps={isSteps}
                                          onClick={() => {
                                            changeTab('operation');
                                            onOpClick(data);
                                            setSelectedUdf(null);
                                          }}
                                          color={
                                            activeOperation?.key === data.key
                                              ? 'secondary'
                                              : 'primary'
                                          }
                                        />
                                      </Box>

                                      {/* DoubleArrow */}
                                      {filteredOperationsArray.length - 1 ===
                                        index ||
                                      !isSteps ||
                                      !data.stepCount ? null : (
                                        <Box sx={{ ml: 1 }}>
                                          <DoubleArrowIcon color="primary" />
                                        </Box>
                                      )}
                                    </Box>
                                  )
                                ),
                                ...udfToShowInOp.map((data) => (
                                  <Box
                                    key={data?.id}
                                    id={`${module}_ops_cards_ops_op_${data?.id}`}
                                    component="ul"
                                    role="list"
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      padding: 0,
                                      margin: 0,
                                      listStyleType: 'none',
                                    }}
                                  >
                                    <Box
                                      component="li"
                                      role="listitem"
                                      sx={{
                                        maxWidth: '200px',
                                      }}
                                    >
                                      <OperationChip
                                        console={true}
                                        data={data}
                                        onClick={() => {
                                          utils.resetConsoleArgs(data);
                                          setSelectedUdf(data);
                                          changeTab('udfs');
                                          onOpClick({ key: ' ' });
                                          navigate(
                                            `/udf-manager/execute/${data?.id}`
                                          );
                                        }}
                                        color={
                                          selectedUdf?.id === data.id
                                            ? 'secondary'
                                            : 'primary'
                                        }
                                      />
                                    </Box>
                                  </Box>
                                )),
                              ]}
                              ariaLabelLeftArrow="Previous Operations"
                              ariaLabelRightArrow="Next Operations"
                            />
                          ) : (
                            <Box>
                              <Box ml={1} mb={1} width={200}>
                                <TransperentSearchBox
                                  placeholder="Search"
                                  onChange={handleOnChange}
                                  value={searchOperationData}
                                  aria-label="Search"
                                />
                              </Box>
                              <Box
                                component="ul"
                                role="list"
                                ml={1}
                                sx={{
                                  padding: 0,
                                  margin: 0,
                                  listStyleType: 'none',
                                  display: 'flex',
                                  flexWrap: 'wrap',
                                  overflow: 'hidden',
                                  justifyContent: 'flex-start',
                                }}
                              >
                                {filteredOperationsArray.length > 0 ||
                                filteredUdfsArray.length > 0 ? (
                                  <>
                                    {filteredOperationsArray?.map(
                                      (data, index) => (
                                        <Box
                                          key={data?.objKey}
                                          id={`${module}_ops_cards_ops_op_${data?.key}`}
                                          component="li"
                                          role="listitem"
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            listStyleType: 'none',
                                          }}
                                        >
                                          <Box>
                                            <OperationChip
                                              data={data}
                                              isSteps={
                                                utils.isValueEmpty(
                                                  searchOperationData
                                                )
                                                  ? isSteps
                                                  : null
                                              }
                                              onClick={() => {
                                                changeTab('operation');
                                                onOpClick(data);
                                                setSelectedUdf(null);
                                              }}
                                              color={
                                                activeOperation?.key ===
                                                data.key
                                                  ? 'secondary'
                                                  : 'primary'
                                              }
                                              className={classes.chip}
                                            />
                                          </Box>
                                          {/* DoubleArrow */}
                                          {filteredOperationsArray.length -
                                            1 ===
                                            index || !isSteps ? null : (
                                            <Box
                                              sx={{ mx: 0.5 }}
                                              display="flex"
                                              flexDirection="row"
                                            >
                                              <DoubleArrowIcon color="primary" />
                                            </Box>
                                          )}
                                        </Box>
                                      )
                                    )}
                                    {udfToShowInOp?.map((data) => (
                                      <Box
                                        key={data?.id}
                                        id={`${module}_ops_cards_ops_op_${data?.id}`}
                                        component="li"
                                        role="listitem"
                                        sx={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          listStyleType: 'none',
                                          overflow: 'hidden',
                                        }}
                                      >
                                        <OperationChip
                                          data={data}
                                          console={true}
                                          onClick={() => {
                                            utils.resetConsoleArgs(data);
                                            setSelectedUdf(data);
                                            changeTab('udfs');
                                            onOpClick({ key: ' ' });
                                            navigate(
                                              `/udf-manager/execute/${data?.id}`
                                            );
                                          }}
                                          color={
                                            selectedUdf?.id === data?.id
                                              ? 'secondary'
                                              : 'primary'
                                          }
                                          className={classes.chip}
                                        />
                                      </Box>
                                    ))}
                                  </>
                                ) : (
                                  <>
                                    {!filteredUdfsArray.length ||
                                    (!filteredOperationsArray.length &&
                                      searchData !== '') ? (
                                      <Box mb={0.4}>
                                        <Typography
                                          variant="body4"
                                          ml={2}
                                          aria-label="No Data"
                                          tabIndex={0}
                                          sx={(theme) => ({
                                            '&:focus-visible': {
                                              outline: 'none',
                                              border: `2px solid ${theme?.palette?.primary?.main} !important`,
                                            },
                                          })}
                                        >
                                          No matching results found!
                                        </Typography>
                                      </Box>
                                    ) : null}
                                  </>
                                )}
                              </Box>
                            </Box>
                          )}
                        </Box>

                        <Grid
                          item
                          xs={1}
                          sx={{ paddingLeft: 1 }}
                          display="flex"
                          alignItems="start"
                        >
                          <Grid item xs={12}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="start"
                            >
                              <IconButton
                                color="primary"
                                onClick={onClickHandler}
                                size="small"
                                aria-description="On activating following button the operation bar will expand or collapse."
                                aria-label={
                                  isOperationExpanded
                                    ? 'Collapse operation'
                                    : 'Expand operation'
                                }
                                aria-expanded={isOperationExpanded}
                                aria-controls={`${module}_operations_panel`}
                              >
                                {isOperationExpanded ? (
                                  <CollapseIcon
                                    color="primary"
                                    id={`${module}_ops_cards_dts_dt_interm_check_box_icon_btn`}
                                    onClick={() => {
                                      setSearchOperationData('');
                                    }}
                                  />
                                ) : (
                                  <ExpandMoreIcon
                                    color="primary"
                                    id={`${module}_ops_cards_dts_dt_add_box_icon_btn`}
                                  />
                                )}
                              </IconButton>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                  </Grid>
                ) : null}
              </Grid>
            </Collapse>
          </Box>
        </StyledBox>
      </Slide>
      <Slide direction="left" in={true} timeout={700}>
        <StyledBox
          sx={{
            width: {
              xs: '100%',
              md: '50%',
            },
            border: 2,
            borderColor: 'secondary.main',
            borderStyle: 'solid',
            padding: '8px',
            borderRadius: 1,
            height: isDataExpanded ? 'auto' : '60px',
          }}
        >
          <Box>
            <Collapse in={isDataExpanded} collapsedSize={46}>
              <Grid item xs={12} sx={{ paddingLeft: 1 }}>
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    alignItems={!isDataExpanded ? 'center' : 'start'}
                  >
                    <Box
                      mt={isDataExpanded && 1}
                      display="flex"
                      alignItems="center"
                      flexDirection="row"
                      mr={1}
                    >
                      <Typography variant="body1" mr={1}>
                        Datasets
                      </Typography>

                      <IconButton
                        title="Refresh dataset list"
                        color="primary"
                        size="small"
                        sx={{ width: '23px', height: '23px' }}
                        onClick={onRefresh}
                        aria-label="Refresh"
                      >
                        <RefreshIcon />
                      </IconButton>
                    </Box>

                    <Box
                      flexGrow={1}
                      overflow="hidden"
                      position="relative"
                      display={datasets?.length ? null : 'flex'}
                      justifyContent={datasets?.length ? null : 'center'}
                      alignItems={datasets?.length ? null : 'center'}
                    >
                      {datasets?.length ? (
                        <Box
                          flexGrow={1}
                          overflow="hidden"
                          position="relative"
                          className={classes.operationDiv}
                        >
                          {!isDataExpanded ? (
                            filteredDatasetsArray?.length !== 0 ? (
                              <CustomCarousel
                                elements={
                                  datasets &&
                                  activeProject?.project_id &&
                                  filteredDatasetsArray?.map((data) => (
                                    <Box
                                      key={data?.id}
                                      id={`${module}_ops_cards_dts_dt_${data?.id}`}
                                      component="li"
                                      role="listitem"
                                      sx={{
                                        listStyleType: 'none',
                                        maxWidth: '200px',
                                      }}
                                    >
                                      <Chip
                                        title={getTitle(data)}
                                        size="small"
                                        sx={{
                                          margin: '4px',
                                          '.MuiChip-icon': {
                                            color: 'initial',
                                            overflow: 'hidden',
                                          },
                                          overflow: 'hidden',
                                        }}
                                        icon={getIcon(data)}
                                        color={
                                          activeDataset?.id === data.id
                                            ? 'secondary'
                                            : 'primary'
                                        }
                                        aria-label={data?.table_display_name}
                                        label={
                                          <Typography
                                            variant="body2"
                                            noWrap={true}
                                            sx={{
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                              whiteSpace: 'nowrap',
                                            }}
                                          >
                                            {data?.table_display_name}
                                          </Typography>
                                        }
                                        onClick={() => {
                                          if (
                                            data?.preprocessed ===
                                            'recalibrating'
                                          ) {
                                            SwalToast({
                                              icon: 'info',
                                              title: DS_RECALIBRATION_MSG,
                                            });
                                            onDqClick(data);
                                          } else if (data?.datalock) {
                                            SwalToast({
                                              icon: 'info',
                                              title: DS_LOCKED_MSG,
                                            });
                                            onDqClick(data);
                                          } else {
                                            onDqClick(data);
                                          }
                                        }}
                                        onContextMenu={(e) => {
                                          showDatasetOperationMenus({
                                            id: `dataset-operation-menus-${data.id}`,
                                            event: e,
                                            props: data,
                                          });
                                        }}
                                      />
                                      <ContextMenus
                                        menuId={`dataset-operation-menus-${data.id}`}
                                        menus={menus}
                                      />
                                    </Box>
                                  ))
                                }
                                ariaLabelLeftArrow="Previous Datasets"
                                ariaLabelRightArrow="Next Datasets"
                              />
                            ) : (
                              <Box
                                component="div"
                                role="alert"
                                aria-live="polite"
                                aria-atomic="true"
                                title={`${filteredDatasetsNotReadyToUseArray.length} dataset(s) available in this project but not marked as ready to use.`}
                                sx={{
                                  ml: 1.4,
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                <Typography variant="body4">
                                  {filteredDatasetsNotReadyToUseArray.length}{' '}
                                  dataset(s) available in this project but not
                                  marked as ready to use.
                                </Typography>
                              </Box>
                            )
                          ) : (
                            <Box>
                              <Box ml={1} mb={1} width={200}>
                                <TransperentSearchBox
                                  placeholder="Search"
                                  onChange={(e) =>
                                    setSearchData(e.target.value)
                                  }
                                  value={searchData}
                                />
                              </Box>
                              <Box
                                overflow="auto"
                                component="ul"
                                role="list"
                                ml={1}
                                mt={0.1}
                                sx={{
                                  display: 'flex',
                                  flexWrap: 'wrap',
                                  justifyContent: 'flex-start',
                                  maxHeight: '40vh',
                                  padding: 0,
                                  margin: 0,
                                  listStyleType: 'none',
                                }}
                              >
                                {datasets &&
                                activeProject?.project_id &&
                                filteredDatasetsArray?.length !== 0 ? (
                                  filteredDatasetsArray?.map((data) => (
                                    <Box
                                      key={data?.id}
                                      id={`${module}_ops_cards_dts_dt_${data?.id}`}
                                      component="li"
                                      role="listitem"
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        listStyleType: 'none',
                                        margin: '0px',
                                        overflow: 'hidden',
                                      }}
                                    >
                                      <Chip
                                        size="small"
                                        title={getTitle(data)}
                                        sx={{
                                          '.MuiChip-icon': {
                                            color: 'initial',
                                          },
                                          overflow: 'hidden',
                                        }}
                                        icon={getIcon(data)}
                                        label={
                                          <Typography
                                            variant="body2"
                                            noWrap={true}
                                            sx={{
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                              whiteSpace: 'nowrap',
                                            }}
                                          >
                                            {data?.table_display_name}
                                          </Typography>
                                        }
                                        onClick={() => {
                                          if (
                                            data?.preprocessed ===
                                            'recalibrating'
                                          ) {
                                            SwalToast({
                                              icon: 'info',
                                              title: DS_RECALIBRATION_MSG,
                                            });
                                            onDqClick(data);
                                          } else if (data?.datalock) {
                                            SwalToast({
                                              icon: 'info',
                                              title: DS_LOCKED_MSG,
                                            });
                                            onDqClick(data);
                                          } else {
                                            onDqClick(data);
                                          }
                                        }}
                                        color={
                                          activeDataset?.id === data.id
                                            ? 'secondary'
                                            : 'primary'
                                        }
                                        className={classes.chip}
                                        onContextMenu={(e) => {
                                          showDatasetOperationMenus({
                                            id: `dataset-operation-menus-${data.id}`,
                                            event: e,
                                            props: data,
                                          });
                                        }}
                                      />
                                      <ContextMenus
                                        menuId={`dataset-operation-menus-${data.id}`}
                                        menus={menus}
                                      />
                                    </Box>
                                  ))
                                ) : (
                                  <Box>
                                    {!searchBasedFilter.length &&
                                    searchData !== '' ? (
                                      <Box mb={0.4}>
                                        <Typography
                                          variant="body4"
                                          ml={2}
                                          aria-label="No data"
                                          tabIndex={0}
                                          sx={(theme) => ({
                                            '&:focus-visible': {
                                              outline: 'none',
                                              border: `2px solid ${theme?.palette?.primary?.main} !important`,
                                            },
                                          })}
                                        >
                                          No matching results found!
                                        </Typography>
                                      </Box>
                                    ) : null}

                                    {filteredDatasetsNotReadyToUseArray.length ? (
                                      <Typography
                                        variant="body4"
                                        tabIndex={0}
                                        sx={(theme) => ({
                                          '&:focus-visible': {
                                            outline: 'none',
                                            border: `2px solid ${theme?.palette?.primary?.main} !important`,
                                          },
                                        })}
                                      >
                                        {
                                          filteredDatasetsNotReadyToUseArray.length
                                        }{' '}
                                        dataset(s) in this project but not
                                        marked as ready to use.
                                      </Typography>
                                    ) : null}
                                  </Box>
                                )}
                              </Box>
                            </Box>
                          )}
                        </Box>
                      ) : (
                        <Box
                          display="flex"
                          alignItems="center"
                          onClick={() => {
                            navigate('/data-management/data-ingestion');
                          }}
                          mt={1}
                          sx={{
                            border: 'none',
                            '&:focus-visible': {
                              border: '1px solid black',
                              borderRadius: '4px',
                              offset: '2px',
                              margin: 'auto',
                            },
                          }}
                          component="button"
                          tabIndex={0}
                        >
                          <DatasetIcon />
                          <Typography
                            variant="body2"
                            noWrap={true}
                            sx={(theme) => ({
                              color: theme.palette.other.lightBrandBlueLogin,
                              textDecoration: 'underline',
                              textDecorationColor:
                                theme.palette.other.lightBrandBlueLogin,
                            })}
                            aria-label="Add dataset"
                          >
                            +Add dataset
                          </Typography>
                        </Box>
                      )}
                    </Box>

                    <Grid
                      item
                      xs={1}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        pl: 1,
                      }}
                    >
                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="start"
                        >
                          <Box display="flex" alignItems="center">
                            <IconButton
                              sx={{
                                '&:focus-visible': {
                                  offset: '1px',
                                  padding: '0px',
                                },
                              }}
                              color="primary"
                              onClick={() => {
                                setIsDataExpanded(!isDataExpanded);
                              }}
                              size="small"
                              aria-description="On activating following button the dataset bar will expand or collapse."
                              aria-expanded={isDataExpanded}
                              aria-label={
                                isDataExpanded
                                  ? 'Collapse dataset'
                                  : 'Expand dataset'
                              }
                              aria-controls={`${module}_data_panel`}
                            >
                              {isDataExpanded ? (
                                <CollapseIcon
                                  color="primary"
                                  id={`${module}_ops_cards_dts_dt_interm_check_box_icon_btn`}
                                  onClick={() => {
                                    setSearchData('');
                                  }}
                                />
                              ) : (
                                <ExpandMoreIcon
                                  color="primary"
                                  id={`${module}_ops_cards_dts_dt_add_box_icon_btn`}
                                />
                              )}
                            </IconButton>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Collapse>
          </Box>
        </StyledBox>
      </Slide>

      {showDeleteModal && (
        <DeleteConfirmModal
          open={showDeleteModal}
          onCloseClick={handleCloseDeleteModal}
          onDeleteClick={handleDeleteDataset}
          confirmationMsg={`Are you sure you want to delete ${deleteDatasetId.table_display_name} ?`}
          resourceName="Dataset"
        />
      )}
      {showRecalibrateModal && (
        <RecalibrationModal
          open={showRecalibrateModal}
          onClose={handleCloseRecalibrateModal}
          onRecalibrateClick={handleRecalibrateDataset}
        />
      )}
    </>
  );
};

OperationCards.defaultProps = {
  isSteps: false,
  selectedUdf: null,
};

OperationCards.propTypes = {
  onOpClick: PropTypes.func.isRequired,
  activeOperation: PropTypes.oneOfType([PropTypes.object]).isRequired,
  operations: PropTypes.oneOfType([PropTypes.object]).isRequired,
  activeDataset: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
    .isRequired,
  onDqClick: PropTypes.func.isRequired,
  datasets: PropTypes.oneOfType([PropTypes.array]).isRequired,
  activeProject: PropTypes.oneOfType([PropTypes.object]).isRequired,
  isSteps: PropTypes.bool,
  module: PropTypes.string.isRequired,
  subModule: PropTypes.string.isRequired,
  trackEntryExitTime: PropTypes.func.isRequired,
  project: PropTypes.oneOfType([PropTypes.object]).isRequired,
  // fetchAllDatasets: PropTypes.func.isRequired,
  udfs: PropTypes.oneOfType([PropTypes.array]).isRequired,
  setSelectedUdf: PropTypes.func.isRequired,
  selectedUdf: PropTypes.oneOfType([PropTypes.object]),
  changeTab: PropTypes.func.isRequired,
  fetchDatasetList: PropTypes.func.isRequired,
};

export default OperationCards;
